import {
  LOAD_CREATE_OPERATION_DATA,
  CREATE_OPERATION_DATA_LOADED,
  CREATE_OPERATION_DATA_ERROR,
  DELETE_OPERATION_SUCCESS,
  SAVE_OPERATION,
  SAVE_OPERATION_SUCCESS,
  SAVE_OPERATION_ERROR,
  UPDATE_QUOTE_OPERATION,
  UPDATE_PRICE_QUOTE_OPERATION,
  UPDATE_VALUES_QUOTE_OPERATION,
  QUOTE_OPERATION,
  QUOTE_OPERATION_SUCCESS,
  QUOTE_OPERATION_ERROR,
  DELETE_OPERATION,
  CLEAR_SAVE_OPERATION,
} from '../constants/create-operation';

import { updateValuesOperation } from '../models/create-operation';

const createOperation = {
  quoteOperations: [],
  createOperationFilters: {},
  createOperationLoading: false,
  createOperationLoadingError: false,
};

export default (state = createOperation, action) => {
  switch (action.type) {
    case LOAD_CREATE_OPERATION_DATA:
      return {
        ...state,
        createOperationLoading: true,
      };

    case CREATE_OPERATION_DATA_ERROR:
      return {
        ...state,
        createOperationLoading: false,
        createOperationLoadingError: true,
      }

    case CREATE_OPERATION_DATA_LOADED:
      return {
        ...state,
        createOperationLoading: false,
        createOperationFilters: action.filters,
        quoteOperations: action.quoteOperations || [],
      };

    case QUOTE_OPERATION:
      return {
        ...state,
        createOperationSuccess: false,
        createOperationLoading: true,
      };

    case UPDATE_VALUES_QUOTE_OPERATION:
      return {
        ...state,
        quoteOperations: state.quoteOperations.map(operation => (
          operation.id === action.operationId
            ? {
              ...updateValuesOperation({
                comissionSlider: action.comissionSlider,
                operation,
              })
            }
            : operation
        ))
      };

    case UPDATE_PRICE_QUOTE_OPERATION:
      return {
        ...state,
        updateOperationLoading: true,
        quoteOperations: state.quoteOperations.map(operation => (
          operation.id === action.operation.id
            ? {
              ...operation,
              updateLoading: true,
            }
            : operation
        ))
      };

    case UPDATE_QUOTE_OPERATION:
      return {
        ...state,
        quoteOperations: state.quoteOperations.map(operation => (
          operation.id === action.operation.id
            ? {
              ...action.operation,
              updateLoading: false
            }
            : operation
        ))
      };

    case QUOTE_OPERATION_SUCCESS:
      return {
        ...state,
        createOperationLoading: false,
        quoteOperations: [...state.quoteOperations, action.operation],
      };

    case QUOTE_OPERATION_ERROR:
      return {
        ...state,
        createOperationLoading: false,
      };

    case SAVE_OPERATION:
      return {
        ...state,
        createOperationSuccess: false,
        createOperationLoading: true,
      };

    case SAVE_OPERATION_SUCCESS:
      return {
        ...state,
        createOperationSuccess: true,
        createOperationLoading: false,
        quoteOperations: state.quoteOperations.filter(({ id }) => id !== action.operation.id),
      };

    case SAVE_OPERATION_ERROR:
      return {
        ...state,
        createOperationLoading: false,
      };

    case CLEAR_SAVE_OPERATION:
      return {
        ...state,
        createOperationSuccess: false,
      };

    case DELETE_OPERATION:
      return {
        ...state,
        createOperationLoading: true,
      };

    case DELETE_OPERATION_SUCCESS:
      return {
        ...state,
        createOperationLoading: false,
        quoteOperations: state.quoteOperations.filter(operation => operation.id !== action.operation.id),
      };

    default:
      return state;
  }
};
